import { $ } from "@/plug/Axios";

export default {
  /**
   * 班主任满意度
   */
  appraiseEmployee_applyAppraise: {
    /*
     * 班主任评分
     * content json, itemId|score|reason (string query required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/server/appraiseEmployee/applyAppraise", p, c)
  },
  appraiseEmployee_detailForService: {
    /*
     * 详情-服务管理-满意度评分
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/appraiseEmployee/detailForService", p, c)
  },
  appraiseEmployee_eduDetail: {
    /*
     * 详情-教学教务-满意度评分
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/appraiseEmployee/eduDetail", p, c)
  },
  appraiseEmployee_exportEduDetail: {
    /*
     * 教学教务-满意度评分详情-导出
     */
    get: (p, c) =>
      $.get("/api/ems/server/appraiseEmployee/exportEduDetail", p, c)
  },
  appraiseEmployee_exportForEdu: {
    /*
     * 教学教务-满意度评分-导出
     */
    get: (p, c) => $.get("/api/ems/server/appraiseEmployee/exportForEdu", p, c)
  },
  appraiseEmployee_finish: {
    /*
     * 标记完成-教学教务-满意度评分
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/server/appraiseEmployee/finish", p, c)
  },
  appraiseEmployee_init: {
    /*
     * 添加-教学教务-满意度评分
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/server/appraiseEmployee/init", p, c)
  },
  appraiseEmployee_listForEdu: {
    /*
     * 教学教务-满意度评分-列表
     */
    get: (p, c) => $.get("/api/ems/server/appraiseEmployee/listForEdu", p, c)
  },
  appraiseEmployee_listForEduDetail: {
    /*
     * 教学教务-满意度评分详情-列表
     */
    get: (p, c) =>
      $.get("/api/ems/server/appraiseEmployee/listForEduDetail", p, c)
  },
  appraiseEmployee_listForSelf: {
    /*
     * 教学教务-满意度评分确认-列表
     */
    get: (p, c) => $.get("/api/ems/server/appraiseEmployee/listForSelf", p, c)
  },
  appraiseEmployee_listForService: {
    /*
     * 服务管理-满意度评分-列表
     */
    get: (p, c) =>
      $.get("/api/ems/server/appraiseEmployee/listForService", p, c)
  },
  appraiseEmployee_listItem: {
    /*
     * 考核项列表
     */
    get: (p, c) => $.get("/api/ems/server/appraiseEmployee/listItem", p, c)
  },
  appraiseEmployee_listItemFor360: {
    /*
     * 考核项列表-360度评测
     */
    get: (p, c) =>
      $.get("/api/ems/server/appraiseEmployee/listItemFor360", p, c)
  },
  appraiseEmployee_listSimple: {
    /*
     * 简易列表
     * type type:360度评测 (string query required)
     */
    get: (p, c) => $.get("/api/ems/server/appraiseEmployee/listSimple", p, c)
  },
  appraiseEmployee_listSimpleScoreByItemId: {
    /*
     * 具体班主任评分数据-教学教务-满意度评分
     * id id (integer query required)
     * itemId 具体项ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/appraiseEmployee/listSimpleScoreByItemId", p, c)
  },
  appraiseEmployee_publish: {
    /*
     * 下发评分-教学教务-满意度评分
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/server/appraiseEmployee/publish", p, c)
  },
  appraiseEmployee_removeEmployee: {
    /*
     * 教学教务-满意度评分-删除
     * id recordId (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/server/appraiseEmployee/removeEmployee", p, c)
  },
  appraiseEmployee_removeRecord: {
    /*
     * 教学教务-满意度评分详情-删除
     * id recordId (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/server/appraiseEmployee/removeRecord", p, c)
  },
  appraiseEmployee_saveItem: {
    /*
     * 添加编辑考核项
     * id  (integer query )
     * itemContent 指标标准/计算公式 (string query )
     * itemName 考核项目 (string query )
     * itemStandard 指标 (string query )
     * proportion 权重 (integer query )
     * sorting 排序 (integer query )
     * type 类型: 评分|绩效 (string query )
     */
    post: (p, c) => $.post("/api/ems/server/appraiseEmployee/saveItem", p, c)
  },
  appraiseEmployee_updateAppraise: {
    /*
     * 编辑评分-教学教务-满意度评分详情
     * content json, itemId|score|reason (string query required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/server/appraiseEmployee/updateAppraise", p, c)
  },

  /**
   * 班级
   */
  classRoom: {
    /*
     * 添加
     * batch 批次 (string query )
     * courseTableStatus 是否已排课 (string query )
     * courseTableTemplate 课表模板 (string query )
     * employTeacherId 就业老师id (integer query )
     * endTime 结束时间 (string query )
     * graduatedStatus 是否已毕业 (string query )
     * headerTeacherId 班主任id (integer query )
     * id  (integer query )
     * level 层次 (string query )
     * majorDirection 专业方向 (string query )
     * name 班级名称 (string query )
     * siteId 学校id (integer query )
     * startTime 开始时间 (string query )
     * term 当前学期 (integer query )
     */
    post: (p, c) => $.post("/api/ems/server/classRoom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/server/classRoom", p, c)
  },
  classRoom_batchUpdateTerm: {
    /*
     * 批量修改当前学期
     * ids 班级id (array query required)
     * term 当前学期 (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/classRoom/batchUpdateTerm", p, c)
  },
  classRoom_downloadModuleForCont: {
    /*
     * 下载模版(职教学校平台)
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/downloadModuleForCont", p, c)
  },
  classRoom_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/export", p, c)
  },
  classRoom_exportForCont: {
    /*
     * 导出(职教学校平台)
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/exportForCont", p, c)
  },
  classRoom_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/list", p, c)
  },
  classRoom_listAllForCourseTableTemplate: {
    /*
     * 所有班级（排课用）
     * courseTableTemplate 课表模板 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/listAllForCourseTableTemplate", p, c)
  },
  classRoom_listForCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listForCont", p, c)
  },
  classRoom_listForTeacher: {
    /*
     * 列表（讲师）
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listForTeacher", p, c)
  },
  classRoom_listSelectIdForCourseTableTemplate: {
    /*
     * 已排课班级id（排课用）
     * courseTableTemplate 课表模板 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/classRoom/listSelectIdForCourseTableTemplate",
        p,
        c
      )
  },
  classRoom_listSimple: {
    /*
     * 简易列表
     * batch 批次 (string query )
     * employStatus 是否内部员工 (string query )
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listSimple", p, c)
  },
  classRoom_listSimpleForCont: {
    /*
     * 简易列表(职教学校平台)
     * batch 批次 (string query )
     * majorDirection 学院 (string query )
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listSimpleForCont", p, c)
  },
  classRoom_listSimpleForHeaderTeacher: {
    /*
     * 班主任所负责班级简易列表
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/listSimpleForHeaderTeacher", p, c)
  },
  classRoom_listSimpleForSubstituteTeacher: {
    /*
     * 代班老师所负责班级简易列表
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/listSimpleForSubstituteTeacher", p, c)
  },
  classRoom_listSimpleForTeacher: {
    /*
     * 简易列表(教师)
     * currentStatus 是否当前，默认全部 (string query )
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listSimpleForTeacher", p, c)
  },
  classRoom_updateCourseTableTemplate: {
    /*
     * 更新课表模板
     * classRoomIds 班级id (array query required)
     * courseTableTemplate 课表模板 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/classRoom/updateCourseTableTemplate", p, c)
  },
  classRoom_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/server/classRoom/upload", p, c)
  },
  classRoom_uploadForCont: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/server/classRoom/uploadForCont", p, c)
  },

  /**
   * 投诉
   */
  complaint: {
    /*
     * 添加
     * appeal 诉求 (string query )
     * attach 附件 (string query )
     * contactPhone 联系手机号 (string query )
     * content 投诉内容 (string query )
     * createId 创建人 (integer query )
     * effectiveStatus 是否为有效投诉：是、否 (string query )
     * filingTime 归档时间 (string query )
     * firstCommunicationTime 首次沟通时间 (string query )
     * handleAdminId 处理人 (integer query )
     * handleTime 处理时间 (string query )
     * id  (integer query )
     * module 模块 (string query )
     * result 处理结果：已撤销、未撤销 (string query )
     * schoolRollId 合同id (integer query )
     * status 状态：处理中，已处理，已归档 (string query )
     * subType 子分类 (string query )
     * targetId 投诉对象 (integer query )
     * type 分类 (string query )
     */
    post: (p, c) => $.post("/api/ems/server/complaint", p, c)
  },
  complaint_changeHandleAdmin: {
    /*
     * 更换处理人
     * adminId 处理人 (integer query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/complaint/changeHandleAdmin", p, c)
  },
  complaint_filing: {
    /*
     * 归档
     * effectiveStatus 结果 (string query required)
     * id id (integer query required)
     * result 结果 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/complaint/filing", p, c)
  },
  complaint_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/complaint/list", p, c)
  },
  complaint_listModule: {
    /*
     * 模块列表
     */
    get: (p, c) => $.get("/api/ems/server/complaint/listModule", p, c)
  },
  complaint_listSubType: {
    /*
     * 子类列表
     * type 分类 (string query required)
     */
    get: (p, c) => $.get("/api/ems/server/complaint/listSubType", p, c)
  },
  complaint_listType: {
    /*
     * 分类列表
     */
    get: (p, c) => $.get("/api/ems/server/complaint/listType", p, c)
  },
  complaint_transferHandleAdmin: {
    /*
     * 移交处理人
     * adminId 原处理人 (integer query required)
     * newAdminId 新处理人 (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/complaint/transferHandleAdmin", p, c)
  },

  /**
   * 投诉处理
   */
  complaintHandle_hand: {
    /*
     * 处理
     * attach 附件 (string query )
     * communication 沟通情况 (string query required)
     * complaintId 投诉id (integer query required)
     * status 是否已处理：是|否 (string query required)
     */
    post: (p, c) => $.post("/api/ems/server/complaintHandle/hand", p, c)
  },
  complaintHandle_listByComplaintId: {
    /*
     * 根据投诉id获取处理列表
     * complaintId 投诉id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/complaintHandle/listByComplaintId", p, c)
  },

  /**
   * 寄书管理
   */
  mailBook_getFrontAgreementInfo: {
    /*
     * C端获取寄书确认内容
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/getFrontAgreementInfo", p, c)
  },
  mailBook_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/list", p, c)
  },
  mailBook_listCourse: {
    /*
     * 书本列表
     * ableStatus 启用禁用 (string query )
     * schoolRollId 合同编号 (integer query required)
     * type 类型: 已寄|未寄 (string query required)
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/listCourse", p, c)
  },
  mailBook_listForDetail: {
    /*
     * 学生详情页面展示的列表
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/listForDetail", p, c)
  },
  mailBook_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/server/mailBook/remove", p, c)
  },
  mailBook_save: {
    /*
     * 添加编辑
     * courseIds 选择的书本列表 (array query required)
     * mailNo 快递单号 (string query )
     * name 邮寄名称 (string query required)
     * postTime 邮寄时间 (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/server/mailBook/save", p, c)
  },
  mailBook_searchById: {
    /*
     * 书本列表
     * id 行ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/searchById", p, c)
  },
  mailBook_updateMailNo: {
    /*
     * 编辑快递单号
     * id id (integer query required)
     * mailNo 快递单号 (string query required)
     * name 邮寄名称 (string query required)
     * postTime 邮寄时间 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/mailBook/updateMailNo", p, c)
  },
  mailBook_uploadAgreementForClient: {
    /*
     * C端上传寄书确认协议（学生签名）-自考
     * id 邮寄详情ID (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/mailBook/uploadAgreementForClient", p, c)
  },

  /**
   * 邮寄表
   */
  mailService: {
    /*
     * 添加
     * allCount 总人数 (integer query )
     * deadline 截止时间 (string query )
     * examBatch 寄书批次-自考考期 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * rollGrade 学籍年级 (string query )
     * siteType 学校类型 (string query )
     */
    post: (p, c) => $.post("/api/ems/server/mailService", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/server/mailService", p, c)
  },
  mailService_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/list", p, c)
  },
  mailService_listForClient: {
    /*
     * C端列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/listForClient", p, c)
  },
  mailService_listName: {
    /*
     * 名字列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/listName", p, c)
  },
  mailService_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/listSimple", p, c)
  },
  mailService_searchLatestForClient: {
    /*
     * C端查询最后的一次邮寄记录, 取地址用
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailService/searchLatestForClient", p, c)
  },
  mailService_updateDeadline: {
    /*
     * 编辑截止时间
     * deadline 截止时间 (string query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/mailService/updateDeadline", p, c)
  },

  /**
   * 邮寄表详情
   */
  mailServiceRecord: {
    /*
     * 添加
     * address 具体地址 (string query )
     * city 市 (string query )
     * district 区 (string query )
     * id  (integer query )
     * mailNo 快递单号 (string query )
     * mailServiceId 邮寄表ID (integer query )
     * phone 手机号 (string query )
     * province 省 (string query )
     * schoolRollId 学籍id (integer query )
     */
    post: (p, c) => $.post("/api/ems/server/mailServiceRecord", p, c)
  },
  mailServiceRecord_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/server/mailServiceRecord/export", p, c)
  },
  mailServiceRecord_exportForService: {
    /*
     * 导出（服务）
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailServiceRecord/exportForService", p, c)
  },
  mailServiceRecord_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/mailServiceRecord/list", p, c)
  },
  mailServiceRecord_listForAdultMail: {
    /*
     * 成考教材邮寄列表
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailServiceRecord/listForAdultMail", p, c)
  },
  mailServiceRecord_listForService: {
    /*
     * 列表（服务）
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailServiceRecord/listForService", p, c)
  },
  mailServiceRecord_saveForClient: {
    /*
     * 成考教材邮寄-c端提交
     * address 具体地区 (string query required)
     * city 市 (string query required)
     * district 区 (string query required)
     * phone 手机 (string query required)
     * province 省 (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/mailServiceRecord/saveForClient", p, c)
  },
  mailServiceRecord_searchForClient: {
    /*
     * 成考教材邮寄-c端查询
     * batch 批次 (string query )
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailServiceRecord/searchForClient", p, c)
  },
  mailServiceRecord_updateMailNo: {
    /*
     * 编辑快递单号
     * id id (integer query required)
     * mailNo 快递单号 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/mailServiceRecord/updateMailNo", p, c)
  },
  mailServiceRecord_uploadMailNo: {
    /*
     * 导入快递单号
     * excelFile excelFile (file formData required)
     * mailServiceId id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/server/mailServiceRecord/uploadMailNo", p, c)
  },

  /**
   * 班主任评分
   */
  schoolRollAppraise_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/schoolRollAppraise/list", p, c)
  },
  schoolRollAppraise_listBySchoolRollId: {
    /*
     * 根据合同编号查询评价记录
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/schoolRollAppraise/listBySchoolRollId", p, c)
  },
  schoolRollAppraise_save: {
    /*
     * 添加
     * appraise 评语 (string query )
     * grade  (string query )
     * headerTeacherId  (integer query )
     * id  (integer query )
     * operatorId 点评人 (integer query )
     * schoolRollId 学籍ID (integer query )
     */
    post: (p, c) => $.post("/api/ems/server/schoolRollAppraise/save", p, c)
  },

  /**
   * 服务打回
   */
  serviceBack_apply: {
    /*
     * 申请
     * remark 备注 (string query )
     * schoolRollId 学籍id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/server/serviceBack/apply", p, c)
  },
  serviceBack_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/serviceBack/details", p, c)
  },
  serviceBack_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/serviceBack/list", p, c)
  },
  serviceBack_listSimple: {
    /*
     * 简易列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/serviceBack/listSimple", p, c)
  },

  /**
   * 服务联系记录
   */
  serviceContact: {
    /*
     * 添加
     * attach 附件 (string query )
     * content 内容 (string query )
     * createId 发起人 (integer query )
     * endTime  (string query )
     * id  (integer query )
     * loseRiskLevel 流失风险等级（职教合同用） (string query )
     * preContactTime 预计下次联系时间 (string query )
     * recordDetail  (string query )
     * schoolRollId 学籍id (integer query )
     * startTime  (string query )
     * type 类型：0普通 1聊天记录 (integer query )
     */
    post: (p, c) => $.post("/api/ems/server/serviceContact", p, c)
  },
  serviceContact_getDetail: {
    /*
     * 聊天记录详情，type=1时取
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/serviceContact/getDetail", p, c)
  },
  serviceContact_listPage: {
    /*
     * 简易列表-带分页
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/serviceContact/listPage", p, c)
  },
  serviceContact_listSimple: {
    /*
     * 简易列表
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/serviceContact/listSimple", p, c)
  },
  serviceContact_repairLastContact: {
    /*
     * 修复最近一次聊天记录
     * schoolRollId schoolRollId (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/server/serviceContact/repairLastContact", p, c)
  },
  serviceContact_updateWeComBindStatus: {
    /*
     * 测试-临时方法更新企微绑定状态
     */
    post: (p, c) =>
      $.post("/api/ems/server/serviceContact/updateWeComBindStatus", p, c)
  },

  /**
   * 学历服务信息
   */
  serviceSchoolRoll_assign: {
    /*
     * 分配班主任
     * headerTeacherId 班主任id (integer query required)
     * ids 服务信息id (array query required)
     * message 移交企微时发送给学生的消息 (string query )
     * syncWechat 企微学生是否同步移交 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/serviceSchoolRoll/assign", p, c)
  },
  serviceSchoolRoll_assignForContinue: {
    /*
     * 分配班主任-继教院
     * headerTeacherId 班主任id (integer query required)
     * ids 服务信息id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/assignForContinue", p, c)
  },
  serviceSchoolRoll_assignForExemptionDegree: {
    /*
     * 分配班主任-免试专升本
     * headerTeacherId 班主任id (integer query required)
     * ids 服务信息id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/assignForExemptionDegree", p, c)
  },
  serviceSchoolRoll_batchChangeHeaderTeacher: {
    /*
     * 批量更换班主任
     * headerTeacherId 班主任id (integer query required)
     * ids 服务id (array query required)
     * message 移交企微时发送给学生的消息 (string query )
     * syncWechat 企微学生是否同步移交 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/batchChangeHeaderTeacher", p, c)
  },
  serviceSchoolRoll_batchChangeHeaderTeacherForContinue: {
    /*
     * 批量更换班主任-继教院
     * headerTeacherId 班主任id (integer query required)
     * ids 服务id (array query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/server/serviceSchoolRoll/batchChangeHeaderTeacherForContinue",
        p,
        c
      )
  },
  serviceSchoolRoll_batchChangeHeaderTeacherForExemptionDegree: {
    /*
     * 批量更换班主任-免试专升本
     * headerTeacherId 班主任id (integer query required)
     * ids 服务id (array query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/server/serviceSchoolRoll/batchChangeHeaderTeacherForExemptionDegree",
        p,
        c
      )
  },
  serviceSchoolRoll_birthdayToday: {
    /*
     * 当天生日学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/birthdayToday", p, c)
  },
  serviceSchoolRoll_changeHeaderTeacher: {
    /*
     * 移交班主任
     * headerTeacherId 班主任id (integer query required)
     * message 移交企微时发送给学生的消息 (string query )
     * originHeaderTeacherId 原班主任id (integer query required)
     * syncWechat 企微学生是否同步移交 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/changeHeaderTeacher", p, c)
  },
  serviceSchoolRoll_clearWeComBind: {
    /*
     * 清空企微绑定
     * schoolRollId 学籍ID (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/clearWeComBind", p, c)
  },
  serviceSchoolRoll_countContactByDays: {
    /*
     * 距离上次联系时间天数
     * days 天数 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/countContactByDays", p, c)
  },
  serviceSchoolRoll_countOverdueContact: {
    /*
     * 首次联系逾期学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/countOverdueContact", p, c)
  },
  serviceSchoolRoll_countUnContact: {
    /*
     * 未联系学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/countUnContact", p, c)
  },
  serviceSchoolRoll_exportStudentForExemptionDegree: {
    /*
     * 服务学生列表导出（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/serviceSchoolRoll/exportStudentForExemptionDegree",
        p,
        c
      )
  },
  serviceSchoolRoll_initFirstContact: {
    /*
     * 初始化首次联系记录
     */
    post: (p, c) =>
      $.post("/api/ems/server/serviceSchoolRoll/initFirstContact", p, c)
  },
  serviceSchoolRoll_listSimpleStudent: {
    /*
     * 简单服务学生列表(班主任所带)
     * batch 批次 (string query )
     * classRoomIds 班级id (array query )
     * level 层次 (string query )
     * majorId 专业id (integer query )
     * siteId 学校id (integer query )
     * siteType 学校类型 (string query )
     * statuses 学籍状态 (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/listSimpleStudent", p, c)
  },
  serviceSchoolRoll_listStudentByReceptionTeacher: {
    /*
     * 高校学生列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/serviceSchoolRoll/listStudentByReceptionTeacher",
        p,
        c
      )
  },
  serviceSchoolRoll_listStudentForExemptionDegree: {
    /*
     * 服务学生列表（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/serviceSchoolRoll/listStudentForExemptionDegree",
        p,
        c
      )
  },
  serviceSchoolRoll_listUnAssignForExemptionDegree: {
    /*
     * 未分配学生列表(免试专升本)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/serviceSchoolRoll/listUnAssignForExemptionDegree",
        p,
        c
      )
  },
  serviceSchoolRoll_remark: {
    /*
     * 备注
     * id id (integer query required)
     * remark 标签 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/serviceSchoolRoll/remark", p, c)
  },
  serviceSchoolRoll_saveAppraise: {
    /*
     * 添加班主任评语
     * appraise 评语 (string query required)
     * grade 评语 (string query required)
     * headerTeacherId 班主任id (integer query required)
     * operatorId 评价人ID (integer query required)
     * schoolRollId 学籍ID (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/serviceSchoolRoll/saveAppraise", p, c)
  },
  serviceSchoolRoll_sendUnAssignNoticeToAdminTeacher: {
    /*
     * 发送未分配班主任钉钉通知到招生老师
     */
    post: (p, c) =>
      $.post(
        "/api/ems/server/serviceSchoolRoll/sendUnAssignNoticeToAdminTeacher",
        p,
        c
      )
  },
  serviceSchoolRoll_syncAdultForContinue: {
    /*
     * 同步成教班主任
     * siteId 学校id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/syncAdultForContinue", p, c)
  },
  serviceSchoolRoll_updatePhotoForContinue: {
    /*
     * 更新个人照|高中毕业证书
     * diplomaNo 高中毕业证编号 (string query )
     * diplomaPhoto 高中毕业证 (string query )
     * educationLevel 层次 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * id id (integer query required)
     * photo 个人照 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/updatePhotoForContinue", p, c)
  },
  serviceSchoolRoll_uploadChangeHeaderTeacher: {
    /*
     * 导入更换班主任
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/server/serviceSchoolRoll/uploadChangeHeaderTeacher",
        p,
        c
      )
  },
  serviceSchoolRoll_uploadPhotoForContinue: {
    /*
     * 批量导入个人照|高中毕业证书
     * idCardNo 身份证 (string query required)
     * photo 地址 (string query )
     * type type: 0全部更新 1个人照 2高中毕业证 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/uploadPhotoForContinue", p, c)
  },

  /**
   * 服务学生统计
   */
  serviceStudentStatistics_autoCountContinueSchoolingStudent: {
    /*
     * 测试-定时任务，每月1号凌晨查询继教院在读人数
     * currentTime 时间 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/ems/server/serviceStudentStatistics/autoCountContinueSchoolingStudent",
        p,
        c
      )
  },
  serviceStudentStatistics_init: {
    /*
     * 测试-初始化学生企微联系次数
     * month 年 (integer query required)
     * year 年 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/server/serviceStudentStatistics/init", p, c)
  },
  serviceStudentStatistics_repairPeriod: {
    /*
     * 测试-班主任服务周期数据初始化
     */
    post: (p, c) =>
      $.post("/api/ems/server/serviceStudentStatistics/repairPeriod", p, c)
  },

  /**
   * 学生通知
   */
  studentMessage_detail: {
    /*
     * 通知内容详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/studentMessage/detail", p, c)
  },
  studentMessage_detailForClient: {
    /*
     * c端-我的通知详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/studentMessage/detailForClient", p, c)
  },
  studentMessage_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/ems/server/studentMessage/downloadMould", p, c)
  },
  studentMessage_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/studentMessage/list", p, c)
  },
  studentMessage_listForClient: {
    /*
     * c端-我的通知列表
     */
    get: (p, c) => $.get("/api/ems/server/studentMessage/listForClient", p, c)
  },
  studentMessage_listStudentDetail: {
    /*
     * 已读|未读学生列表
     * id id (integer query required)
     * name 学生姓名 (string query )
     * readStatus 已读状态 (string query )
     * wechatFollowStatus 公众号关注状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/server/studentMessage/listStudentDetail", p, c)
  },
  studentMessage_publish: {
    /*
     * 发布
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/studentMessage/publish", p, c)
  },
  studentMessage_resend: {
    /*
     * 重新发送
     * id 已读|未读学生列表返回的id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/studentMessage/resend", p, c)
  },
  studentMessage_save: {
    /*
     * 添加编辑
     * content 内容 (string query )
     * extraUrl 附件地址 (string query )
     * id ID编辑传入 (integer query )
     * keyword1 关键字1 (string query )
     * keyword2 关键字2 (string query )
     * keyword3 关键字3 (string query )
     * keyword4 关键字4 (string query )
     * keyword5 关键字5 (string query )
     * templateId 模板id (integer query )
     * title 标题 (string query )
     */
    post: (p, c) => $.post("/api/ems/server/studentMessage/save", p, c)
  },
  studentMessage_uploadReceiver: {
    /*
     * 导入收件人
     * excelFile excelFile (file formData required)
     * studentMessageId 通知ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/server/studentMessage/uploadReceiver", p, c)
  }
};
